import { fileShareNewFolderClick } from '@wix/bi-logger-wixlabs-ugc/v2';

export const biFileShareWidgetNewFolderClick = (props: any) => {
  const {
    instance_id,
    app_id,
    logger,
    visitor_id,
    comp_id,
    is_first,
    owner,
  } = props;
  logger?.report(
    fileShareNewFolderClick({
      instance_id,
      app_id,
      visitor_id,
      comp_id,
      is_first,
      owner,
    }),
  );
};
